function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Letters");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon-letters"
}, React.createElement("g", {
  id: "noun_Letter_2621463-Copy",
  opacity: 0.7,
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M1.99264327,0.560759037 C1.7175952,0.560759037 1.49463156,0.783750384 1.49460404,1.05879846 L1.49460404,5.07132147 L0.705717702,5.63404753 C0.575351074,5.72760584 0.498039228,5.87824065 0.498039228,6.0387044 L0.498039228,15.0038968 C0.498039228,15.1360653 0.550595244,15.2628096 0.644098062,15.3562212 C0.737600881,15.4496328 0.864396401,15.5019363 0.996564817,15.5019363 L14.9411768,15.5019363 C15.2162249,15.5019363 15.4392161,15.2789449 15.4392161,15.0038968 L15.4392161,6.0387044 C15.4387642,5.8778876 15.360695,5.72718329 15.2295921,5.63404753 L14.4431376,5.07229439 L14.4431376,1.05879846 C14.4431244,0.926629995 14.3905816,0.799885704 14.2970788,0.706474107 C14.203576,0.613062511 14.0767805,0.560759037 13.9446121,0.560759037 L1.99264327,0.560759037 Z M2.49068248,1.55683768 L13.4465728,1.55683768 L13.4465728,6.49540239 L7.96862765,10.4082204 L2.49068248,6.49540239 L2.49068248,1.55683768 Z M14.4431376,7.00657367 L14.4431376,14.5053713 L1.49460404,14.5053713 L1.49460404,7.00803268 L7.6782668,11.4247262 C7.85150392,11.5485464 8.08429212,11.5485464 8.25752925,11.4247262 L14.4431376,7.00657367 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "3.98345591 3.05147294 3.98345591 4.04779294 6.97242645 4.04779294 6.97242645 3.05147294"
}), React.createElement("polygon", {
  id: "Path",
  points: "3.98345591 5.04227765 3.98345591 6.03860706 11.9522061 6.03860706 11.9522061 5.04227765"
}))), React.createElement("rect", {
  id: "Rectangle-Copy-11",
  stroke: "#979797",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15
})));

const SvgRenewalsLetters = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRenewalsLetters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/renewals-letters.757e52d6.svg";
export { ForwardRef as ReactComponent };